<template>
  <app-modal modal-id="renewe-modal"
             modal-size="default"
             modal-alignment="top"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">
        {{ selectedUrl ? $t("edit_renewe") : $t("add_renewe") }}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form ref="form" v-if="dataLoaded" :data-url="selectedUrl ? selectedUrl : `crm/renewes`">
        <div class="form-group mb-3">
            <div class="row">
                <div class="mb-0 col-sm-5 d-flex align-items-center">
                    <label>{{ $t("status") }}</label>
                </div>
                <div class="col-sm-7">
                    <app-input v-model="formData.status" :error-message="$errorMessage(errors, 'status')" :list="statusList"
                        list-value-field='name' :placeholder="$t('choose_status')" type="select" />
                </div>
            </div>
        </div>
        <div class="form-group mb-3">
            <div class="row">
                <label class="col-5 mb-0 d-flex align-items-center">{{ $t('person_res') }}</label>
                <div class="col-7">
                    <app-input v-model="formData.person_id" :required="true" :error-message="$errorMessage(errors, 'rest')" :list="peopleListRe"
                        list-value-field='name' :placeholder="$t('choose_res')" type="search-select" />
                </div>
            </div>
        </div>
        <div class="form-group mb-5">
            <div class="row">
                <div class="mb-0 col-sm-5 d-flex align-items-center">
                    <label>{{ $t("price") }}</label>
                </div>
                <div class="col-sm-4">
                    <app-input v-model="formData.price" :error-message="$errorMessage(errors, 'price')"
                        :placeholder="$t('enter_price')" type="text" />
                </div>
                <div class="col-sm-1"></div>
                <div class="col-2">
                    <app-input v-model="formData.price_symbol" :error-message="$errorMessage(errors, 'symbol')"
                        :list="symbolList" list-value-field='name' :placeholder="$t('choose_symbol')" type="select" />
                </div>
            </div>
        </div>
        <div class="form-group mt-3 mb-3">
            <div class="row">
                <label class="col-5 mb-0 d-flex align-items-center">{{ $t('date_on') }}</label>
                <div class="col-7">
                    <app-input v-model="formData.date_on" :placeholder="$t('choose_a_date')" :popover-position="'left-start'"
                        type="date" />
                </div>
            </div>
        </div>
        <div class="form-group mb-3">
            <div class="row">
                <label class="col-5 mb-0 d-flex align-items-center">{{ $t('date_off') }}</label>
                <div class="col-7">
                    <app-input v-model="formData.date_off" :placeholder="$t('choose_a_date')" :popover-position="'left-start'"
                        type="date" />
                </div>
            </div>
        </div>
        
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button type="button" class="btn btn-primary" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import {mapGetters} from "vuex";

export default {
    name: "ReneweModal",
    mixins: [FormSubmitMixin],
    props: ["fundData", "selectedUrl"],
    data() {
        return {
            isOrganizationModalActive: false,
            addMoreDetails: false,
            dataLoaded: true,
            countryList: [],
            formData: {
                owner_id: user.id,
                creatted_by: user.id,
                status: 1,
                price_symbol: 1,
            },
            addEditData: {},
            statusList: [
                {
                    id: 1,
                    name: this.$t('status_renewe_process'),
                },
                {
                    id: 2,
                    name: this.$t('status_renewe_done'),
                },
            ],
            symbolList: [
                {
                    id: 1,
                    name: '₴',
                },
                {
                    id: 2,
                    name: '$',
                },
            ],


        };
    },
    computed: {
        peopleListRe() {
			return this.$store.getters.getPersonRe;
		},
    },
    methods: {

        beforeSubmit() {
            this.loading = true;
        },
        submit() {



            this.addEditData.fund_id = this.fundData.id;
            this.addEditData.person_id = this.formData.person_id;
            this.addEditData.price = this.formData.price;
            this.addEditData.price_symbol = this.formData.price_symbol;
            this.addEditData.status = this.formData.status;


            this.addEditData.date_on = this.formData.date_on ? moment(this.formData.date_on).format(
                "YYYY-MM-DD"
            ) : null;
            this.addEditData.date_off = this.formData.date_off ? moment(this.formData.date_off).format(
                "YYYY-MM-DD"
            ) : null;

            this.addEditData.owner_id = this.formData.owner_id;
            this.addEditData.created_by = this.formData.created_by;



            this.save(this.addEditData);
        },
        afterSuccessFromGetEditData(response) {
            this.formData = response.data;

        },
    },
    created() {

		this.$store.dispatch('getPersonRe');
		
	},
};
</script>
